import { useNavigate } from 'react-router-dom';
import { EmptyResults } from '../../shared-mui-components/ListMessages.tsx';
import { ZoneMapView } from './ZoneMapView.tsx';
import { ZoneEnforcedDTO } from './Zones.tsx';

export function ZonesMap({ zones }: { zones: ZoneEnforcedDTO[] }) {
    const navigate = useNavigate();
    const zonesWithGeodata = zones
        .filter(zone => zone.geodataText)
        .map(zone => {
            return {
                id: zone.zoneId,
                externalName: zone.zoneName,
                externalId: zone.zoneCode,
                geodataText: zone.geodataText,
            };
        });

    if (zonesWithGeodata.length < 1) {
        return <EmptyResults />;
    }

    return (
        <ZoneMapView
            zonesData={zonesWithGeodata}
            onZoneClick={id => navigate(`${id}`)}
        />
    );
}
